



























































import { Vue, Prop, Component } from "vue-property-decorator";

// Components
import ReportRecordsListing from "@/components/app/admin/insights/reportRecordsListing.vue";

@Component({
  components: {
    "report-provider": () =>
      import("@/components/app/admin/insights/reportProvider.vue"),
    "report-records-listing": () =>
      import("@/components/app/admin/insights/reportRecordsListing.vue"),
    "generated-reports-listing": () =>
      import("@/components/app/admin/insights/generatedReportsListing.vue")
  }
})
export default class ReportOverview extends Vue {
  public $refs!: {
    reportRecordsListing: ReportRecordsListing;
  };
  // Props

  @Prop({ required: true })
  public reportCode!: any;

  @Prop({ default: () => () => ({}) })
  public routeFilters!: (
    vm?: ReportRecordsListing
  ) => Record<string, string | number | boolean>;

  // Computed

  public get manualFilters() {
    return {
      ...this.routeFilters()
    };
  }
}
